import { IDefferedRequestsRes } from "../../models/admin/deferred.model";
import getService from "../getService";
import postService from "../postService";

const CONFIG_API_URL =
  process.env.REACT_APP_API_BASE_URL || 'http://20.126.75.78/naptin/api/v1/';

const GETMYDEFERREQUESTS = "user/my-defer-admission-requests";
const PROCESSDEFERADMISSIONREQUEST = "admin/process-defer-admission-requests";
const GETDEFERADMISSIONREQUESTS = "admin/get-defer-admission-requests/";
const GETADEFERADMISSIONREQUEST = "admin/get-defer-admission-requests/";
const TRAINEEDEFERREQUEST = 'course-enrollments/';
const ADMINDEFERADMISSION = 'admin/defer-admission'
export default class DefermentService {
  static async getMyDeferedRequests() {
    const response = await getService.get(CONFIG_API_URL + GETMYDEFERREQUESTS);
    const data: any = response.data;
    return data;
  }

  static async processDeferRequest(payload: any) {
    const response = await postService.post(CONFIG_API_URL + PROCESSDEFERADMISSIONREQUEST,payload);
    const data: any = response.data;
    return data;
  }
  static async traineeDeferRequest(uuid : string | undefined,payload: any) {
    const response = await postService.post(CONFIG_API_URL + TRAINEEDEFERREQUEST + uuid + '/' + 'defer-request',payload);
    const data: any = response.data;
    return data;
  }
  static async adminDeferAdmission(payload: any) {
    const response = await postService.post(CONFIG_API_URL + ADMINDEFERADMISSION,payload);
    const data: any = response.data;
    return data;
  }
  static async getDeferredAdmissionRequests(status : string | undefined ,limit : string | undefined) {
    const response = await getService.get(CONFIG_API_URL + GETDEFERADMISSIONREQUESTS + status + '/' + limit);
    const data: IDefferedRequestsRes = response.data;
    return data;
  }
  static async getADeferredAdmissionRequest(id: string) {
    const response = await getService.get(CONFIG_API_URL + GETADEFERADMISSIONREQUEST + id);
    const data: any = response.data;
    return data;
  }
}
